__turbopack_context__.v({
  "divider": "RelatedEvents-module-scss-module__3137Ia__divider",
  "dividerContainer": "RelatedEvents-module-scss-module__3137Ia__dividerContainer",
  "hiddenSeoCopy": "RelatedEvents-module-scss-module__3137Ia__hiddenSeoCopy",
  "relatedEventsContainer": "RelatedEvents-module-scss-module__3137Ia__relatedEventsContainer",
  "subtitle": "RelatedEvents-module-scss-module__3137Ia__subtitle",
  "title": "RelatedEvents-module-scss-module__3137Ia__title",
});
